import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // <--- Agregar esta importación
import axios from 'axios';
import App from './App';
import './index.css';
import './mobile.css';
import reportWebVitals from './reportWebVitals';

const API_BASE = process.env.REACT_APP_API_URL || window.__APP_API_BASE__ || 'http://localhost:4000';
window.__APP_API_BASE__ = API_BASE;

const getStoredAuth = () => {
  try { return JSON.parse(localStorage.getItem('auth') || '{}'); } catch { return {}; }
};

const attachAuthHeaders = (headers = new Headers()) => {
  const auth = getStoredAuth();
  if (auth?.appToken && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${auth.appToken}`);
  }
  const saToken = localStorage.getItem('saToken');
  if (saToken && !headers.has('x-sa-token')) {
    headers.set('x-sa-token', saToken);
  }
  // Portales de personal (camareras y trabajadores): sesión emitida al entrar con Google
  const portalToken = localStorage.getItem('portalToken');
  if (portalToken && !headers.has('x-portal-token')) {
    headers.set('x-portal-token', portalToken);
  }
  return headers;
};

// La sesión de un portal de personal venció o es anterior a los tokens: vuelve a entrar con Google
const PORTALES = [['/camarera/', 'camareraAuth', '/camarera/login'], ['/trabajador/', 'trabAuth', '/trabajador/login'], ['/personal', 'camareraAuth', '/login']];
const alVencerPortal = (response) => {
  if (response.status !== 401 || response.headers.get('x-portal-auth') !== 'required') return response;
  const portal = PORTALES.find(([prefijo]) => window.location.pathname.startsWith(prefijo));
  if (portal && !/\/(login|registro)$/.test(window.location.pathname)) {
    localStorage.removeItem(portal[1]);
    localStorage.removeItem('portalToken');
    window.location.href = portal[2];
  }
  return response;
};

const normalizeBackendUrl = (url) => String(url || '')
  .replace(/^http:\/\/127\.0\.0\.1:4000/i, API_BASE)
  .replace(/^http:\/\/localhost:4000/i, API_BASE);

const nativeFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const rawUrl = typeof input === 'string' ? input : input?.url || '';
  const url = normalizeBackendUrl(rawUrl);
  const isBackendCall = url.startsWith(API_BASE) || url.startsWith('/api/');
  if (!isBackendCall) return nativeFetch(input, init);

  const headers = attachAuthHeaders(new Headers(init.headers || (input instanceof Request ? input.headers : undefined)));
  if (typeof input === 'string') {
    return nativeFetch(url, { ...init, headers }).then(alVencerPortal);
  }
  return nativeFetch(new Request(url, input), { ...init, headers }).then(alVencerPortal);
};

axios.defaults.baseURL = API_BASE;
axios.interceptors.request.use((config) => {
  const auth = getStoredAuth();
  const saToken = localStorage.getItem('saToken');
  if (config.url) config.url = normalizeBackendUrl(config.url);
  config.headers = config.headers || {};
  if (auth?.appToken && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${auth.appToken}`;
  }
  if (saToken && !config.headers['x-sa-token']) {
    config.headers['x-sa-token'] = saToken;
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// Envolver <App /> con <BrowserRouter>
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

// ─── Registrar Service Worker (PWA) para portal de camareras y staff ─────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then(reg => console.log('[SW] Registrado — scope:', reg.scope))
      .catch(err => console.warn('[SW] Registro fallido:', err));
  });
}
